<template>
  <div>
    <md-table v-model="users" class="md-table-global-sales">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
<!--
        <md-table-cell md-label="">
          <div class="flag"><img :src="item.flag" /></div>
        </md-table-cell>
-->
        <md-table-cell>{{ item.name }}</md-table-cell>
        <md-table-cell>{{ item.count }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
export default {
  name: "global-sales-table",
  data() {
    return {
      selected: [],
      users: [
        {
          // flag: "./img/flags/US.png",
          name: "New",
          count: "2",
        },
        {
          // flag: "./img/flags/DE.png",
          name: "Waiting on Customer",
          count: "6",
        },
        {
          // flag: "./img/flags/AU.png",
          name: "On Hold",
          count: "1",
        },
        {
          // flag: "./img/flags/GB.png",
          name: "Solved",
          count: "21",
        },
        {
          //flag: "./img/flags/RO.png",
          name: "Closed",
          count: "95",
        }
      ]
    };
  }
};
</script>
